<template>
    <div v-if="pagination.total > 0">
        <ul class="pagination">
            <li class="page-item" :class="{disabled: pagination.current_page <= 1}"><a class="page-link" @click="handleOnClickFirstPage()">|&lt;</a></li>
            <li class="page-item" :class="{disabled: pagination.current_page <= 1}"><a class="page-link" @click="handleOnClickPreviousPage()">&lt;</a></li>
            <li class="page-item" v-for="page in pages" :key="page" :class="{active: page === pagination.current_page}">
                <a class="page-link" @click="handleOnClickTargetPage(page)">{{ page }}</a>
            </li>
            <li class="page-item" :class="{disabled: pagination.current_page >= pagination.total_pages}"><a class="page-link" @click="handleOnClickNextPage()">&gt;</a></li>
            <li class="page-item" :class="{disabled: pagination.current_page >= pagination.total_pages}"><a class="page-link" @click="handleOnClickLastPage()">&gt;|</a></li>
        </ul>
        <div class="mt-1 text-center">{{ $t('paginate.total1') }} {{ pagination.total }} {{ $t('paginate.total2') }} {{ pagination.from }} - {{ pagination.to }} {{ $t('paginate.display') }}</div>
    </div>
</template>
<script>
    export default {
        name: 'paginate',
        props: {
            pagination: Object,
        },
        methods: {
            calcFromTo() {
                if (this.pagination.total_pages < this.pagination.current_page) {
                    return;
                }
                this.pagination.from = (this.pagination.current_page - 1) * this.pagination.per_page + 1;
                this.pagination.to = this.pagination.current_page * this.pagination.per_page;
                if (this.pagination.to > this.pagination.total) {
                    this.pagination.to = this.pagination.total;
                }
            },
            handleOnClickFirstPage() {
                if (this.pagination.current_page <= 1) {
                    return;
                }
                this.pagination.current_page = 1;
                this.$emit('change-page');
            },
            handleOnClickPreviousPage() {
                if (this.pagination.current_page <= 1) {
                    return;
                }
                this.pagination.current_page--;
                this.$emit('change-page');
            },
            handleOnClickTargetPage(page) {
                if (this.pagination.current_page === page) {
                    return;
                }
                this.pagination.current_page = page;
                this.$emit('change-page');
            },
            handleOnClickNextPage() {
                if (this.pagination.current_page >= this.pagination.total_pages) {
                    return;
                }
                this.pagination.current_page++;
                this.$emit('change-page');
            },
            handleOnClickLastPage() {
                if (this.pagination.current_page >= this.pagination.total_pages) {
                    return;
                }
                this.pagination.current_page = this.pagination.total_pages;
                this.$emit('change-page');
            }
        },
        computed: {
            pages() {
                this.calcFromTo();
                let start = (this.pagination.current_page - 2) > 1 ? this.pagination.current_page - 2 : 1;
                let end;
                if ((start + 4) < this.pagination.total_pages) {
                    end = start + 4;
                } else {
                    end = this.pagination.total_pages;
                    if ((end - 4) < start) {
                        start = (end - 4) > 1 ? (end - 4) : 1;
                    }
                }
                let pages = [];
                for (let i = start; i <= end; i++) {
                    pages.push(i);
                }
                return pages;
            }
        }
    }
</script>

<style scoped>
    .pagination {
        justify-content: center;
        flex-wrap: wrap;
        row-gap: 6px;
    }

    @media (max-width: 480px) {
        .page-link {
            padding: 0.375rem 0.55rem;
            font-size: 13px;
        }
    }

    /* モバイル実機では tap 後も :hover/:active 状態が解除されず、グローバルな
       a:hover { color: $purple; } (src/sass/base/_default.scss) がアクティブページの
       紫背景の上に紫文字を重ねてしまい、テキストが見えなくなる。ページ外をタップして
       初めて解除される、という報告と一致。アクティブなページ番号の文字色は常に白で固定する。 */
    .page-item.active .page-link,
    .page-item.active .page-link:hover,
    .page-item.active .page-link:focus,
    .page-item.active .page-link:active {
        color: #fff;
    }

    /* 同様に "<" "  >" 等の非アクティブなページリンクも、モバイルタップ後に
       Bootstrap の .page-link:hover (グレー背景) が解除されずページ外タップまで
       残ってしまう。実ホバー可能なデバイスのみグレー背景を適用する。 */
    .page-item:not(.active) .page-link:hover {
        background-color: #fff;
        border-color: #dee2e6;
    }

    @media (hover: hover) and (pointer: fine) {
        .page-item:not(.active) .page-link:hover {
            background-color: #e9ecef;
        }
    }
</style>
